export const encodeObject = (data: any) => {
  const jsonString = JSON.stringify(data);
  return btoa(jsonString);
};

export const decodeString = (encodedData: string) => {
  let x = atob(encodedData);

  try {
    return JSON.parse(x);
  } catch (error) {
    console.error("Error parsing decrypted text:", error);
    return null; // Handle the error appropriately in your application
  }
};

export const updateQueryParamsFromString = (queryStringToUpdate: any) => {
  const searchParams = new URLSearchParams(window.location.search);

  // Parse the provided queryStringToUpdate
  const updatedParams = new URLSearchParams(queryStringToUpdate);

  // Iterate through updatedParams and set or update each parameter in searchParams
  updatedParams.forEach((value, key) => {
    searchParams.set(key, value);
  });

  // Get the updated query string
  const updatedQueryString = searchParams.toString();

  // Use history.replaceState to update the URL without triggering a full page reload
  const newUrl =
    window.location.pathname +
    (updatedQueryString ? `?${updatedQueryString}` : "");
  window.history.replaceState({ path: newUrl }, "", newUrl);
};
